export const pressedEnterOrSpaceButton = (ev) => ev.key === 'Enter' || ev.key === ' ';
